import * as React from 'react';
import { CustomSwiper, ICustomSwiperNavigationRef } from '../../CustomSwiper';
import { PROMOS_SWIPER_OPTIONS } from '../../../settings/promos';
import './styles.css';

interface IStandardCarouselProps {
  children: React.ReactElement[];
  navRef: ICustomSwiperNavigationRef;
}

export function PromoCarousel({ children, navRef }: IStandardCarouselProps) {
  return (
    <CustomSwiper className="pik-promos-carousel" {...PROMOS_SWIPER_OPTIONS} navRef={navRef}>
      {children}
    </CustomSwiper>
  );
}
